import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';

import { CustomEventService } from '@shared/services/custom-event.service';
import { WidgetService } from '@shared/services/widget.service';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { WidgetStatePlaceholderEnum } from '@shared/enums/widget-state-placeholder.enum';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-jira-issues-widget',
  templateUrl: './jira-issues-widget.component.html'
})
export class JiraIssuesWidgetComponent implements OnInit {

  TEXT_LENGTH = 60;

  @Input() dateFilterable: boolean;
  widgetId: string;
  widgetName: string;
  widgetType: string;
  widgetFooter: Widget.FooterModel;
  headerAddon: string;
  headerComponents: [] = [];
  selectedDate: string;
  note: string;
  url: string;
  from: number;
  showDownloadIcon: boolean;

  @Input()
  set period(period: string) {
    if (period === 'FROM') {
      this.selectedDate = this.from.toString(10);
    } else if (period === 'TODAY') {
      this.selectedDate = `${period}`;
    } else if (period) {
      this.selectedDate = `FROM_LAST_${period}`;
    }
  };

  isScreenshot: false;
  loading: boolean;
  initialLoading: boolean;
  widgetStatePlaceholderEnum = WidgetStatePlaceholderEnum;
  showWidgetStatePlaceholder: WidgetStatePlaceholderEnum;

  data: JiraIssuesWidget.JiraIssuesWidgetModel;
  widthConfig: string[];

  @ViewChild('toolTipTitle') toolTipTitle: TemplateRef<any>;
  toolTipHTML: string;

  constructor(private widgetService: WidgetService,
              private customEventService: CustomEventService) { }

  ngOnInit(): void {
    this.toolTipHTML = this.headerComponents.join('<br>');

    this.loadWidgetData(true);

    // Subscribe to the dashboard announcements to update
    this.customEventService.eventAnnounced$.pipe(
      untilDestroyed(this)
    ).subscribe(({ action, data }) => {
      if (action === ActionTypesEnum.UPDATE_WIDGET_DATA) {
        this.loadWidgetData();
      }

      if (action === ActionTypesEnum.UPDATE_WIDGET_DATE) {
        const { id, date } = data;

        if (this.widgetId === id ) {
          this.selectedDate = date;
          this.loadWidgetData();
        }
      }

      if (action === ActionTypesEnum.UPDATE_SCREENSHOT) {
        this.isScreenshot = data;
      }
    });
  }

  loadWidgetData(initial?: boolean): void {
    this.loading = true;

    if (initial) {
      this.initialLoading = true;
    }

    this.widgetService.get(this.widgetId, this.selectedDate)
      .pipe(untilDestroyed(this), take(1))
      .subscribe(response => {
        this.loading = false;
        this.initialLoading = false;

        if (!response.data) {
          this.showWidgetStatePlaceholder = this.widgetStatePlaceholderEnum.DATA_NOT_FOUND;
          return;
        }
        this.showWidgetStatePlaceholder = undefined;

        if (response.footer) {
          this.widgetFooter = response.footer;
        }

        this.widthConfig = [];

        this.data = response.data;

        this.data.columns.forEach((item) => {
          this.widthConfig.push(`${item.length * 8 > 40 ? item.length * 8 : 40}`);
        });

        this.data.rows.forEach(row => {
          row.forEach((item, index) => {
            if (item.text && (item.text.length * 8 > +this.widthConfig[index])) {
              this.widthConfig[index] = item.text.length > 40 ? '230' : `${item.text.length * 8}`
            }
          });
        });
        this.widthConfig = this.widthConfig.map(item => `${item}px`);
      }, error => {
        console.log('error while fetching widget data', error);
        this.loading = false;
        this.initialLoading = false;
        this.showWidgetStatePlaceholder = this.widgetStatePlaceholderEnum.DATA_NOT_FOUND;
      });
  }
}
